import { DESTINATIONS_LIST } from 'modules/dataSync/constants/prequel';
import { DestinationTitle, DestinationInfo, StyledPageHeader } from './PageHeader.styles';
import { useDataSyncTranslations } from 'modules/dataSync/hooks/useDataSyncTranslations';
import { Destination } from 'modules/dataSync/contexts/@prequel/type';
import { getDestinationDetails } from 'modules/dataSync/utils';
import React from 'react';
import { PageActions } from './PageActions';

interface PageHeaderProps {
  destination: Destination;
  destinationId: string;
}

export const TransferHistoryPageHeader = ({ destination, destinationId }: PageHeaderProps) => {
  const { t } = useDataSyncTranslations();

  const destinationConfig = DESTINATIONS_LIST[destination.vendor as keyof typeof DESTINATIONS_LIST];
  const IconComponent = destinationConfig?.Icon;
  const vendorName = destinationConfig?.name || 'Unknown Destination';
  const destinationDetails = getDestinationDetails(destination, t);

  const breadcrumb = {
    content: t('transferHistory.breadcrumb'),
    href: '/integrations/dataSync',
  };

  const pageActions = (
    <PageActions destinationId={destinationId} destinationName={destination.name} />
  );

  const pageSubSection = (
    <DestinationInfo>
      {IconComponent && <IconComponent height={16} width={16} />}
      <span>{vendorName}</span>
      {destinationDetails.map((detail, index) => (
        <React.Fragment key={index}>
          <span>•</span>
          <span>{detail}</span>
        </React.Fragment>
      ))}
      <span>•</span>
      <span>{t('transferHistory.transferHistory')}</span>
    </DestinationInfo>
  );

  return (
    <StyledPageHeader
      data-test="destination-transfer-page-header"
      breadcrumb={breadcrumb}
      pageActions={pageActions}
      pageSubSection={pageSubSection}
      documentTitle={`${destination.name} | Data Sync`}
    >
      <DestinationTitle>{destination.name}</DestinationTitle>
    </StyledPageHeader>
  );
};
